import { render, staticRenderFns } from "./Layout66.vue?vue&type=template&id=3acf4d00"
import script from "./Layout66.vue?vue&type=script&lang=js"
export * from "./Layout66.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports